export default __webpack_public_path__ + "static/media/sriram.c7ea02c7f81b08ac892a7baef2ab52cf.webp";